import { lazy } from "react";

const HomePage = lazy(() => import("./Components/js/HomePage/HomePage"));
const Login = lazy(() => import("./Components/js/Login/Login"));
const LoginForm = lazy(() => import("./Components/js/FacebookLogin/FacbookLoginPage"));
const CatalogConnect = lazy(() => import("./Components/js/CatalogConnect/CatalogConnect"));
const Analytics = lazy(() => import("./Components/js/Analytics/Analytics"));
const FileUploadCrm = lazy(() => import("./Components/js/CrmFileUpload/FileUploadCrm"));
const ProductAnalytics = lazy(() => import("./Components/js/ProductAnalytics/ProductAnalytics"));
const Trends1 = lazy(() => import("./Components/js/Trends/Trends1"));
const OfflineAnalytics = lazy(() => import("./Components/js/OfflineAnalytics/OfflineAnalytics"));
const DataConnect = lazy(() => import("./Components/js/DataConnect/DataConnect"));
const Catalog = lazy(() => import("./Components/js/Activation/Catalog"));
const SmartCatalogHeader = lazy(() => import("./Components/js/Activation/SmartCatalogHeader"));
const BecomeSmarter = lazy(() => import("./Components/js/BecomeSmarter/BecomSmarter"));
const CreativeEdit = lazy(() => import("./Components/js/CreativeEditor/CreativeEdit"));
const PrivacyPolicy = lazy(() => import("./Components/js/Footer/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./Components/js/Footer/TermsOfService.js"));
const TemplateHistory = lazy(() => import("./Components/js/CreativeEditor/TemplateRuleHistory/TemplateHistory.jsx"));
const ContactUsOverview = lazy(() => import("./Components/js/ContactUs/ContactUsOverview.jsx"));
const ProductResourceOverview = lazy(() => import("./Components/js/ProductResource/ProductResourceOverview.jsx"));
const ProductSetsOverview = lazy(() => import("./Components/js/Activation/ProductSets/ProductSetsOverview.jsx"));

export const routesMap = [
  {
    path: "/",
    component: HomePage,
    // component: LoginForm,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/data-manager/catalog-connect",
    component: CatalogConnect,
  },
  {
    path: "/data-manager/data-connect",
    component: DataConnect,
  },
  {
    path: "/analytics",
    component: Analytics,
  },
  {
    path: "/analytics/product-analytics",
    component: ProductAnalytics,
  },
  {
    path: "/analytics/trends",
    component: Trends1,
  },
  {
    path: "/analytics/offline-analytics",
    component: OfflineAnalytics,
  },
  {
    path: "/crm-file-upload",
    component: FileUploadCrm,
  },
  {
    path:"/activation/catalog",
    component: Catalog,
  },
  // {
  //   path: "/activation/build-custom-catalog",
  //   component : CustomCatalog,
  // },
  {
    path: "/activation/smart-catalog",
    component :SmartCatalogHeader
  },
  {
    path: "/activation/product-sets",
    component :ProductSetsOverview
  },
  {
    path: "/become-smarter",
    component :BecomeSmarter
  },
  {
    path: "/creatives/edit-creatives",
    component :CreativeEdit
  },
  {
    path: "/creatives/template-rules",
    component :TemplateHistory
  },
  {
    path: "/terms-of-service",
    component :TermsOfService
  },
  {
    path: "/privacy-policy",
    component :PrivacyPolicy
  },
  {
    path: "/contact-us",
    component :ContactUsOverview
  },
    {
    path: "/product-resource",
    component :ProductResourceOverview
  }
];
